import { render, staticRenderFns } from "./ServiceObject.vue?vue&type=template&id=5772d087&"
import script from "./ServiceObject.vue?vue&type=script&lang=js&"
export * from "./ServiceObject.vue?vue&type=script&lang=js&"
import style0 from "./ServiceObject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports